module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedLight.aafb423.woff";